import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { CustomForm } from "../../components";
import { useUpdateUserMutation } from "../../store/api/apiSlice";
import "../../styles/auth.css";
import { Button, Image, Input, SectionHeading, Select } from "../../ui";

const Profile = () => {
  const [updateUser] = useUpdateUserMutation();
  const usersSchoolRef = useRef();
  const interestedSchoolRef = useRef([]);
  const favorite_sportsRef = useRef([]);
  const [selectedRole, setSelectedRole] = useState("");

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    const school_name = usersSchoolRef.current.value;
    const interested_schools = interestedSchoolRef.current.value;
    const favorite_sports = favorite_sportsRef.current.value;
    try {
      const result = await updateUser({
        school_name,
        interested_schools,
        favorite_sports,
      }).unwrap();
      toast.success("User Updated successfully!");
    } catch (err) {
      toast.error("Failed to Update user: ", err);
    }
  };

  return (
    <div className="authWrapper">
      <Image path="/images/headericon.png" alt="Logo" />
      <div className="title-section">
        <SectionHeading>Collegiate Sports Fans Association</SectionHeading>
      </div>
      <div className="row formWrapper">
        <CustomForm onSubmit={handleUpdateSubmit} className="col-5 mx-auto">
          <p className="fieldWrapper">
            <Input
              label="Favorite College"
              placeholder="colg123"
              type="text"
              id="school_name"
              ref={usersSchoolRef}
            />
          </p>
          <p className="fieldWrapper">
            <Select
              label="Interested Schools"
              id="interested_schools"
              options={[
                { value: "nextbridge1", label: "NextBridge1" },
                { value: "nextbridge2", label: "NextBridge2" },
              ]}
              value={selectedRole}
              onChange={setSelectedRole}
              placeholder="Select a role"
            />
          </p>
          <p className="fieldWrapper">
            <Select
              label="Favorite Sports"
              id="favorite_sports"
              options={[
                { value: "footebal", label: "Footbal" },
                { value: "cricket", label: "Cricket" },
              ]}
              value={selectedRole}
              onChange={setSelectedRole}
              placeholder="Select a role"
            />
          </p>
          <p className="buttonWrapper">
            <Button type="submit">Update Profile</Button>
            <Link to="/login">
              <Button>Login</Button>
            </Link>
          </p>
        </CustomForm>
      </div>
    </div>
  );
};

export default Profile;
